import { render } from "./ModalAddSuppliersGroup.vue?vue&type=template&id=082e0c30&scoped=true"
import script from "./ModalAddSuppliersGroup.vue?vue&type=script&lang=js"
export * from "./ModalAddSuppliersGroup.vue?vue&type=script&lang=js"

import "./ModalAddSuppliersGroup.vue?vue&type=style&index=0&id=082e0c30&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-082e0c30"]])

export default __exports__